<template functional>
	<div :class="props.cls">
		<p class="usage-kind-title">{{props.name}}</p>
		<p class="usage-kind-subtitle" v-for="usageKind in props.usageKinds" :key="usageKind">– {{usageKind}}</p>
		<p class="usage-kind-subtitle" v-if="!props.usageKinds.length">—</p>
	</div>
</template>
<script>
	export default {
		props: ['name', 'usageKinds','cls']
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import '../../assets/sass/main.scss';

	.usage-kind-title {
		color: $grey;
		font-weight: normal;
		padding-top: 0.6rem;
	}		

	.usage-kind-subtitle {
		color: #000;
	}	
</style>
